import { pickRequestContextPayload } from './pickRequestContextPayload';
import {
  EMPTY_REQUEST_CONTEXT_PAYLOAD,
  REQUEST_CONTEXT_EVENT,
  type RequestContextPayload
} from './types';

let cachedRequestContext: RequestContextPayload | null = null;

export function getCachedRequestContext(): RequestContextPayload | null {
  return cachedRequestContext;
}

export function setCachedRequestContext(payload: RequestContextPayload): void {
  cachedRequestContext = payload;
}

export function toRequestContextDataLayerEvent(
  payload: RequestContextPayload
): RequestContextPayload & { event: typeof REQUEST_CONTEXT_EVENT } {
  return {
    event: REQUEST_CONTEXT_EVENT,
    ...payload
  };
}

/** Direct dataLayer push — must not go through `$analytics` (Ninetailed). */
export function pushRequestContextToDataLayer(
  payload: RequestContextPayload = cachedRequestContext ??
    EMPTY_REQUEST_CONTEXT_PAYLOAD
): void {
  if (typeof window === 'undefined') {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(toRequestContextDataLayerEvent(payload));
}

export function pushCachedRequestContextToDataLayer(): void {
  if (!cachedRequestContext) {
    return;
  }

  pushRequestContextToDataLayer(cachedRequestContext);
}

export function cacheAndPushRequestContext(
  input: unknown
): RequestContextPayload {
  const payload = pickRequestContextPayload(input);
  setCachedRequestContext(payload);
  pushRequestContextToDataLayer(payload);
  return payload;
}
